import { useQuery } from "react-query";
import axios from "axios";

import { getApiSitePrefix } from "../../functions/SiteDefaults";

const apiSitePrefix = getApiSitePrefix();

const getNextTrip = async (tableRef, queryClient, month, year) => {
    if (tableRef && tableRef.current && tableRef.current.state && tableRef.current.state.lastEditingRow){
        return queryClient.getQueryData(['lasttrip']);
    }
    const { data } = await axios.get(
        `${apiSitePrefix}/trip/next/${year}/${month}`
    );

    if (data) {
        return data;
    }

    return null;
};

export default function useNextTrip(props) {
    const options = {
        ...props.options
    }
    return useQuery(
        ["lasttrip", props.year, props.month],
        () => getNextTrip(props.tableRef, props.queryClient, props.month, props.year),
        options
    );
}